import React from 'react';
import Skeleton from '../../Skeleton/Skeleton';
import NavigationItemSkeleton from '../NavigationItem/NavigationItem.skeleton';
import { getDataTestAttributes } from '../../../utils/testing-locators';
import { SKELETON } from '../../../constants/dataTestIds';
import styles from './NavigationBlock.module.css';

export const config = {
  title: {
    width: '120px',
    height: '20px',
    count: 1,
  },
  items: {
    width: '120px',
    height: '20px',
    count: 4,
  },
};

export const mobileConfig = config;

export const TitleSkeleton = ({ isDesktop = true }) => (
  <Skeleton config={isDesktop && config.title} />
);
export const ItemsSkeleton = ({ isDesktop = true }) => (
  <Skeleton config={isDesktop ? config.items : mobileConfig.items} />
);

export function NavigationBlockSkeleton() {
  return (
    <div
      className={styles['lc-NavigationBlock']}
      {...getDataTestAttributes(SKELETON)}
    >
      <div className={styles['lc-title']}>
        <TitleSkeleton />
      </div>

      <div>
        <NavigationItemSkeleton />
        <NavigationItemSkeleton />
        <NavigationItemSkeleton />
        <NavigationItemSkeleton />
      </div>
    </div>
  );
}

export default NavigationBlockSkeleton;
